// extracted by mini-css-extract-plugin
export default {"contents":"Am_uCBFcIWMAMwalFSBQ"};